angular.module('directives.keypressEvents', [])
  .directive('keypressEvents', ['$document', '$rootScope',
    function($document, $rootScope) {
      return {
        restrict: 'A',
        link: function() {
          $document.bind('keydown', function(event) {
            $rootScope.$broadcast('keypress:' + event.which);
          });
        }
      };
    }
  ]);
